/** Ring buffer activity log for WebMCP tool calls. */

import type { WebMcpLogEntry } from "./types.js";

export class ActivityLog {
  #entries: WebMcpLogEntry[] = [];
  #maxEntries: number;

  constructor(maxEntries = 1000) {
    this.#maxEntries = maxEntries;
  }

  /** Append a log entry, evicting the oldest if at capacity. */
  addEntry(entry: WebMcpLogEntry): void {
    this.#entries.push(entry);
    if (this.#entries.length > this.#maxEntries) {
      this.#entries.shift();
    }
  }

  /** Return the most recent entries (newest last). */
  getEntries(limit?: number): WebMcpLogEntry[] {
    if (limit === undefined || limit >= this.#entries.length) {
      return [...this.#entries];
    }
    return this.#entries.slice(-limit);
  }

  /** Clear all log entries. */
  clear(): void {
    this.#entries = [];
  }

  /** Current entry count. */
  get size(): number {
    return this.#entries.length;
  }
}
